<template>
  <div class="border-right pr-2 mr-1">
    <b-dropdown
      :text="branchData.title"
      variant="light"
      pill
    >
      <template v-for="item in dataList">
        <b-dropdown-item
          v-if="branchData.id !== item.id"
          :key="item.id"
          @click="setBranch(item)"
        >
          {{ item.title }}
        </b-dropdown-item>
      </template>
    </b-dropdown>
  </div>
</template>
<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'

export default {
  name: 'BranchesSelect',
  components: {
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      branchData: JSON.parse(localStorage.getItem('branchData')),
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['userBranches/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    setBranch(data) {
      const { userData } = this
      userData.id_branches = data.id
      localStorage.setItem('userData', JSON.stringify(userData))
      this.userData = userData
      const branchData = {
        id: data.id,
        title: data.title,
      }
      localStorage.setItem('branchData', JSON.stringify(branchData))
      this.branchData = branchData
      this.$store.dispatch('branches/setBranch', data.id)
        .then(response => {
          if (response) {
            // eslint-disable-next-line no-restricted-globals
            location.reload()
          }
        })
    },
    getDataList() {
      this.$store.dispatch('userBranches/getDataList')
    },
  },
}
</script>
